import ApiClient from '@/api/api-client'

export default function() {
    return {
        postCustomerData: function(payload) {
            return ApiClient.post('/check-sample', payload)
        }
    }
}
